import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import API_BASE_URL, { buildApiHeaders } from '../utils/config';
import SiteFooter from '../components/Footer';
import '../App.css';

const ActivateAccount: React.FC = () => {
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Extract token from query string
  const params = new URLSearchParams(location.search);
  const token = params.get('token');
  const paramObj: Record<string, string> = {};

  // Parse and decode token if present
  if (token) {
    try {
      let padded = token;
      if (token.length % 4 !== 0) {
        padded += '='.repeat(4 - (token.length % 4));
      }
      const decoded = atob(padded.replace(/-/g, '+').replace(/_/g, '/'));
      decoded.split('&').forEach(pair => {
        const [key, value] = pair.split('=');
        paramObj[key] = value;
      });
    } catch (err) {
      console.log('Failed to decode token:', err);
    }
  }

  const handleActivate = async (e: React.FormEvent) => {
    e.preventDefault();
    setMessage('');
    setError('');
    setLoading(true);
    try {
      if (!paramObj['em'] || !paramObj['org'] || !paramObj['et']) {
        setError('Invalid activation link. Please request a new one.');
        return;
      }

      const res = await fetch(`${API_BASE_URL}/activate_user`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: paramObj['em'],
          org: paramObj['org'],
          activation_code: 'activate', // Placeholder, backend will handle activation logic
        }),
      });
      if (res.ok) {
        setMessage('Your account has been activated! You can now log in.');
        setTimeout(() => navigate('/login'), 2000);
      } else {
        setError('Failed to activate account. The link may have expired.');
      }
    } catch (err) {
      setError('Failed to activate account.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="nf-form-container">
      <button className="nf-home-btn" type="button" onClick={() => navigate('/')} aria-label="Close">&#10005;</button>
      <h2 className="nf-form-title">Complete Your Registration</h2>
      <form className="nf-form" onSubmit={handleActivate}>
        <button className="nf-btn nf-btn-primary nf-form-btn" type="submit" disabled={loading}>
          {loading ? 'Activating...' : 'Activate My Account'}
        </button>
      </form>
      <div className="nf-info-section" style={{ marginTop: '1.5rem', fontSize: '1.05rem' }}>
        By activating your account, you agree to our <a href="/terms" target="_blank" rel="noopener noreferrer">Terms of Use</a> and promise not to abuse or misuse this website. Thank you for helping us keep NeutralFit safe and welcoming for everyone.
      </div>
      {message && <div className="nf-success">{message}</div>}
      {error && <div className="nf-error">{error}</div>}
      <SiteFooter style={{ marginTop: '30px' }} />
    </div>
  );
};

export default ActivateAccount;
